import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  ViewEncapsulation,
} from "@angular/core";
import { LineItemMonitorMeta } from "../line-item-monitor.model";
import { AppService } from "src/app/app.service";
@Component({
  selector: "app-line-item-period-edit",
  templateUrl: "./line-item-period-edit.component.html",
  host: { class: "line-item-period-grid" },
  styleUrls: ["./line-item-period-edit.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class LineItemPeriodEditComponent implements OnInit {
  @Output() onItemChange: EventEmitter<any> = new EventEmitter();
  @Input() lineItemsMeta: LineItemMonitorMeta;
  @Input() periodIndex: number;
  @Input() ticker: string;
  selectedPeriod: string;
  selectedPeriodValue: string;
  relativeToCurrentPeriodList: Array<string>;
  periodValue = "";
  periods: Array<any> = [];
  relativePeriod: string;
  typeHeaders = {
    y: "Annual",
    q: "Quarter",
    h: "Half Year",
  };
  periodObject: any;

  constructor(private appService: AppService) {}

  ngOnInit() {
    this.relativePeriod =
      this.lineItemsMeta.relative_periods[this.periodIndex - 1];
    const periodType = this.lineItemsMeta.period_range;
    this.periods = Object.keys(periodType).map((key) => ({
      type: key,
      range: periodType[key],
      typeHeader: this.typeHeaders[key],
    }));
    this.periodValue = this.relativePeriod.substr(0, 1);
    this.selectedPeriod = this.relativePeriod.substr(1)
      ? `+ ${this.relativePeriod.substr(1)}`
      : `+ 1`;
    this.selectedPeriodValue = this.selectedPeriod;
    this.onFetchPeriodRange();
    this.appService.logUserAction(
      {},
      this.ticker,
      "NMV",
      "MONITOR_CUSTOMIZE_PERIODS",
      {
        company_id: this.lineItemsMeta.companyid,
        beginning_state_referrer: "COMPANY_PAGE_MONITOR",
      },
      "",
      "MONITOR_CUSTOMIZE_PERIODS_SELECTOR",
    );
  }

  onFetchPeriodRange() {
    this.periodObject = this.periods.find(
      (period) => period.type === this.periodValue,
    );
    const { range = 1 } = this.periodObject || {};
    this.relativeToCurrentPeriodList = [...Array(range).keys()].map(
      (r) => `+ ${r + 1}`,
    );
  }

  emitPerod() {
    this.onItemChange.emit([
      this.periodValue,
      this.selectedPeriodValue.slice(2),
    ]);
  }

  onChangePeriod() {
    this.selectedPeriod = `+ 1`;
    this.selectedPeriodValue = this.selectedPeriod;
    this.onFetchPeriodRange();
  }

  onSelectPeriod(data: any) {
    this.selectedPeriod = data;
    this.selectedPeriodValue = this.selectedPeriod;
  }

  applyPeriodSelections() {
    this.emitPerod();
    this.appService.logUserAction(
      {},
      this.ticker,
      "NMV",
      "MONITOR_SAVE_PERIODS",
      {
        company_id: this.lineItemsMeta.companyid,
        beginning_state_referrer: "COMPANY_PAGE_MONITOR",
      },
      "",
      "MONITOR_CUSTOMIZE_PERIODS_SELECTOR",
    );
  }

  closeEditPeriodPopUp() {
    this.onItemChange.emit([]);
  }
}
